import { useQuery } from "@tanstack/react-query";
import type { PartnerHomeResponse } from "@mfa-aff/shared";
import { partnerHomeMock } from "../mocks/partner";
import { get } from "./client";
import { partnerPaths } from "./paths";

export const homeKey = ["partner", "home"] as const;

/** `GET /home`: balances, level card, this month, one suggested action, 90-day series, recent commissions. */
export const useHome = () => useQuery({ queryKey: homeKey, queryFn: () => get<PartnerHomeResponse>(partnerPaths.home, () => partnerHomeMock()) });
